type Props = {
  children: string;
};
const Title = ({children}: Props) => {
  return <strong className="tit_g">{children}</strong>;
};
export default Title;
